import { OpenApiRenderEngine } from "./renderEngine";
var openApiRenderEngine = {
  name: "open-api-render-engine",
  component: OpenApiRenderEngine,
  sourceTypes: ["open-api", "openapi", "swagger"]
};
export { openApiRenderEngine };